import React, { useState } from "react";
import { apiLogin } from "./api.js";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const user = await apiLogin(email.trim(), password);
      onLogin(user);
    } catch (e) {
      const detail = e?.response?.data?.detail;
      setErr(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="hh-login-page" data-testid="login-page">
      <div className="hh-login-card">
        <div className="hh-login-hdr">
          <div className="hh-login-logo-wrap">
            <img
              src="/logo-hh.png"
              alt="Happy Hands"
              className="hh-login-logo-img"
            />
          </div>
          <div className="hh-login-title">FIELD SMART</div>
          <div className="hh-login-sub">HR &amp; Payroll Management System</div>
        </div>
        <form className="hh-login-body" onSubmit={submit}>
          {err ? (
            <div className="hh-login-err" data-testid="login-error">
              {err}
            </div>
          ) : null}
          <label htmlFor="login-email">Email</label>
          <input
            id="login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            required
            data-testid="login-email-input"
          />
          <label htmlFor="login-password">Password</label>
          <input
            id="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
            required
            data-testid="login-password-input"
          />
          <button
            type="submit"
            className="hh-login-btn"
            disabled={busy}
            data-testid="login-submit-btn"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
